import { LocationSwitcher } from "src/components/LocationSwitcher";
import { useNavigate } from "react-router-dom";
import Spinner from "src/components/Spinner";
import { useDealers } from "src/context/DealersContext";
import { Container, LoadingContainer } from "./LocationSwitcherPage.styles";

export default () => {
  const navigate = useNavigate();
  const { dealerOptions, isLoading } = useDealers();
  if (dealerOptions.length === 1) {
    const dealer = dealerOptions[0];
    if (dealer.dealer_id === "porchpass") {
      void navigate("/porchpass/dealers", { replace: true });
    } else {
      void navigate(`/${dealer.dealer_id ?? ""}/dashboard`, { replace: true });
    }
  }
  if (isLoading) {
    return (
      <Container>
        <LoadingContainer>
          <Spinner variant="blue" />
        </LoadingContainer>
      </Container>
    );
  }

  if (dealerOptions.length === 0) {
    return (
      <Container>
        <div>No locations available.</div>
      </Container>
    );
  }

  return (
    <Container>
      <LocationSwitcher dealerOptions={dealerOptions} />
    </Container>
  );
};
